import React, { useState } from "react";
import '../styles/Auth.css';
import { Box } from "@mui/material";
import AuthForm from "../components/AuthForm";
import SwitchLocal from "../components/SwitchLocal";


export default function Auth() {
    const [passwordShown, setPasswordShown] = useState(false);

    const togglePasswordVisibility = () => {
        setPasswordShown(!passwordShown);
    };

    
    return (
        <Box sx={{height: '100vh', overflow: 'hidden'}}>
            <Box sx={{textAlign: 'right', margin: '5px 30px'}}>
                <SwitchLocal/>
            </Box>
            <Box className="AuthPage">
                <AuthForm
                    passwordShown={passwordShown}
                    togglePasswordVisibility={togglePasswordVisibility}
                />
            </Box>
        </Box>
    );
}